import { LoggingEvent } from "../LoggingEvent";
import { LoggingLevel } from "../LoggingLevel";
import { Appender } from "../Appender";
import { Layout } from "../Layout";

/**
 * Обработчик для вывода логов в консоль.
 */
export class BrowserConsoleAppender implements Appender {
  private readonly layout: Layout;

  private readonly loggingLevelToConsoleOutput = new Map<
    LoggingLevel,
    (message: string) => void
  >([
    [LoggingLevel.INFO, console.log],
    [LoggingLevel.ERROR, console.error],
    [LoggingLevel.DEBUG, console.debug],
    [LoggingLevel.WARN, console.warn],
    [LoggingLevel.TRACE, console.trace],
  ]);

  /**
   * Создание обработчика для вывода в консоль.
   *
   * @param layout - макет сообщений для вывода в консоль.
   */
  constructor(layout: Layout) {
    this.layout = layout;
  }

  public doAppend(event: LoggingEvent) {
    const methodForLogging = this.getMethodForLogging(event.level);
    methodForLogging && methodForLogging(this.layout.format(event));
  }

  /**
   * Если присутствует консоль, вернет метод для вывода иначе undefined.
   */
  private getMethodForLogging(loggingLevel: LoggingLevel) {
    if (console && this.loggingLevelToConsoleOutput.has(loggingLevel)) {
      return this.loggingLevelToConsoleOutput.get(loggingLevel);
    } else {
      return undefined;
    }
  }
}
